import * as React from 'react';
import { is, fromJS } from 'immutable';

interface IProps {
    isOpen: boolean;
    title?: string;
    className?: string;
    hiddenHeader?: boolean;
    size?: string;
    onClose: () => void;
    destroy?: () => {};
}

interface IState {
}

class Modal extends React.Component<IProps, IState>{
    constructor(props) {
        super(props);
    }
    static confirm: (option) => void;
    //关闭弹窗
    close() {
        const { destroy, onClose } = this.props;
        onClose && onClose();
        destroy && destroy();
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !is(fromJS(this.props), fromJS(nextProps)) || !is(fromJS(this.state), fromJS(nextState))
    }
    render() {
        const { title = '提示', isOpen, className = '', hiddenHeader, size } = this.props;
        
        return (
            <div className={['w-modal-wrap', className, size ? 'w-modal-' + size : ''].join(' ')} style={isOpen ? { display: 'block' } : { display: 'none' }}>
                <div className="w-modal-spacer"></div>
                <div className="w-modal">
                    <div className="w-modal-inner">
                        {!hiddenHeader && <div className="w-modal-header">{title}</div>}
                        <div className="w-modal-close" onClick={this.close.bind(this)}></div>
                        <div className="w-modal-body">
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;